import { Animal, Plant, Rock, Structure } from '../world.js';

/**
 * Entity validation system to prevent component conflicts
 */
export class EntityValidator {
    constructor() {
        this.conflictCount = 0;
        this.lastLogTime = 0;
    }
    
    /**
     * Validate entity components and clean up conflicts
     */
    validateEntity(entityId) {
        const components = [];
        
        // Check which components are active
        if (Animal.type[entityId] > 0) components.push('Animal');
        if (Plant.type[entityId] > 0) components.push('Plant');
        if (Rock.type[entityId] > 0) components.push('Rock');
        if (Structure.type[entityId] > 0) components.push('Structure');
        
        // Log conflicts if any
        if (components.length > 1) {
            this.conflictCount++;
            const now = Date.now();
            
            // Only log every 5 seconds to avoid spam
            if (now - this.lastLogTime > 5000) {
                console.warn(`[EntityValidator] Entity #${entityId} has conflicting components:`, components);
                console.warn(`[EntityValidator] Component values:`, {
                    plant: Plant.type[entityId],
                    animal: Animal.type[entityId],
                    rock: Rock.type[entityId],
                    structure: Structure.type[entityId]
                });
                this.lastLogTime = now;
            }
            
            // Auto-fix: Keep only the primary component
            this.fixEntityConflict(entityId, components);
        }
        
        return components;
    }
    
    /**
     * Fix entity conflicts by keeping only the primary component
     */
    fixEntityConflict(entityId, components) {
        // Priority order: Animal > Plant > Structure > Rock
        const priority = ['Animal', 'Plant', 'Structure', 'Rock'];
        
        for (const comp of priority) {
            if (components.includes(comp)) {
                // Keep this component, clear others
                if (comp !== 'Animal') Animal.type[entityId] = 0;
                if (comp !== 'Plant') Plant.type[entityId] = 0;
                if (comp !== 'Rock') Rock.type[entityId] = 0;
                if (comp !== 'Structure') Structure.type[entityId] = 0;
                
                console.log(`[EntityValidator] Fixed entity #${entityId} - kept ${comp} component`);
                break;
            }
        }
    }
    
    /**
     * Get conflict statistics
     */
    getStats() {
        return {
            totalConflicts: this.conflictCount,
            lastLogTime: this.lastLogTime
        };
    }
    
    /**
     * Reset statistics
     */
    resetStats() {
        this.conflictCount = 0;
        this.lastLogTime = 0;
    }
}

// Export singleton instance
export const entityValidator = new EntityValidator();
